export const areaCodes = {
    '0101': '01',
    '6201': 71,
    '6001': 75,
    '5901': 79,
    '0301': 11,
    '0601': 15,
    '0901': 19,
    '1501': 23,
    '2701': 27,
    '2101': 31,
    '3001': 35,
    '3901': 39,
    '3301': 43,
    '4301': 47,
    '5801': 61,
    '4501': 55,
    '4801': 59,
    '1801': 63,
    '7101': 10,
    '7001': 33,
    '7201': 62,
    '51': 51,
};

export const regions = [
    { code: '', ru: 'Все', kk: 'Бәрі', en: 'All' },
    { code: '01', ru: 'Республика Казахстан', kk: 'Қазақстан Республикасы', en: 'Republic of Kazakhstan' },
    { code: '71', ru: 'Астана', kk: 'Астана', en: 'Astana' },
    { code: '75', ru: 'Алматы', kk: 'Алматы', en: 'Almaty' },
    { code: '79', ru: 'Шымкент', kk: 'Шымкент', en: 'Shymkent' },
    { code: '10', ru: 'область Абай', kk: 'Абай облысы', en: 'Abay region' },
    { code: '11', ru: 'Акмолинская область', kk: 'Ақмола облысы', en: 'Akmola region' },
    { code: '15', ru: 'Актюбинская область', kk: 'Ақтөбе облысы', en: 'Aktobe region' },
    { code: '19', ru: 'Алматинская область', kk: 'Алматы облысы', en: 'Almaty region' },
    { code: '23', ru: 'Атырауская область', kk: 'Атырау облысы', en: 'Atyrau region' },
    { code: '63', ru: 'Восточно-Казахстанская область', kk: 'Шығыс Қазақстан облысы', en: 'East Kazakhstan region' },
    { code: '31', ru: 'Жамбылская область', kk: 'Жамбыл облысы', en: 'Zhambyl region' },
    { code: '33', ru: 'область Жетісу', kk: 'Жетісу облысы', en: 'Zhetysu Region' },
    { code: '27', ru: 'Западно-Казахстанская область', kk: 'Батыс Қазақстан облысы', en: 'West Kazakhstan region' },
    { code: '35', ru: 'Карагандинская область', kk: 'Қарағанды  облысы', en: 'Karagandy region' },
    { code: '39', ru: 'Костанайская область', kk: 'Қостанай  облысы', en: 'Kostanay region' },
    { code: '43', ru: 'Кызылординская область', kk: 'Қызылорда  облысы', en: 'Kyzylorda region' },
    { code: '47', ru: 'Мангистауская область', kk: 'Манғыстау  облысы', en: 'Mangistau region' },
    { code: '55', ru: 'Павлодарская область', kk: 'Павлодар  облысы', en: 'Pavlodar region' },
    { code: '59', ru: 'Северо-Казахстанская область', kk: 'Солтүстік  Қазақстан облысы', en: 'North Kazakhstan region' },
    { code: '61', ru: 'Туркестанская область', kk: 'Түркістан облысы', en: 'Turkestan region' },
    { code: '62', ru: 'область Ұлытау', kk: 'Ұлытау облысы', en: 'Ulytau Region' }
];
